(function () {
    'use strict';

    angular.module("imApp").factory("productSearchService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 461,
                    parameters: parms || {}
                });
            },
            listSearchProducts: function (parms) {
                return $ihttp.post({
                    method: 462,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
